import { Member } from "Models/members/member";

export const getMemberDescription = (member?: Member, options: { useEmail?: boolean } = {}) => {
  const { useEmail = true } = options;
  const name = member?.firstName || "";
  const lastName = member?.lastName || "";
  const email = member?.email || "";

  const hasText = !!(name || lastName || email);

  if (!hasText) return "";

  const emailLabel = email && useEmail ? ` - ${email}` : "";

  return `${name} ${lastName}${emailLabel}`;
};
